import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Dashboard } from './pages/Dashboard'
import { Compliance } from './pages/Compliance'
import { SelectedDemandAssessment } from './pages/SelectedDemandAssessment'
import { RiskManagement } from './pages/RiskManagement'
import { SelectedRiskAnalysis } from './pages/SelectedRiskAnalysis'
import { Calendar } from './pages/Calendar'
import { RiskEconomy } from './pages/RiskEconomy'
import { SelectedFinancialYear } from './pages/SelectedFinancialYear'
import { NavigationLink } from './interfaces/INavigationLink'
import { RootLayout } from './RootLayout'
import { Components } from './api/schemas/schema'
import { FallbackRedirect } from './components/common/other/FallbackRedirect'
import { ModuleRouteGuard } from './components/common/other/ModuleGuard'

export const Router = () => {
   const router = createBrowserRouter([
      {
         element: <RootLayout />,
         children: [
            {
               path: NavigationLink.Overview,
               element: <Dashboard />,
            },
            {
               path: NavigationLink.AnnualCalendar,
               element: (
                  <ModuleRouteGuard allowedModules={[Components.CALENDAR]}>
                     <Calendar />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: NavigationLink.ComplianceOfDemands,
               element: (
                  <ModuleRouteGuard allowedModules={[Components.DEMAND_COMPLIANCE]}>
                     <Compliance />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: NavigationLink.ComplianceOfDemands + '/:id',
               element: (
                  <ModuleRouteGuard allowedModules={[Components.DEMAND_COMPLIANCE]}>
                     <SelectedDemandAssessment />
                  </ModuleRouteGuard>
               ),
            },

            {
               path: NavigationLink.RiskManagement,
               element: (
                  <ModuleRouteGuard allowedModules={[Components.RISK_MANAGEMENT]}>
                     <RiskManagement />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: NavigationLink.RiskManagement + '/:id',
               element: (
                  <ModuleRouteGuard allowedModules={[Components.RISK_MANAGEMENT]}>
                     <SelectedRiskAnalysis />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: NavigationLink.RiskEconomy,
               element: (
                  <ModuleRouteGuard allowedModules={[Components.RISK_ECONOMY]}>
                     <RiskEconomy />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: NavigationLink.RiskEconomy + '/:id',
               element: (
                  <ModuleRouteGuard allowedModules={[Components.RISK_ECONOMY]}>
                     <SelectedFinancialYear />
                  </ModuleRouteGuard>
               ),
            },
            {
               path: '*',

               element: <FallbackRedirect />,
            },
         ],
      },
   ])
   return <RouterProvider router={router} />
}
